module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_item":"New"},"de":{"new_item":"New"}}')
  delete Component.options._Ctor
}
